class AuthError extends Error {
	constructor(
		message: string,
		public readonly code: string,
		public readonly originalError?: Error
	) {
		super(message)
		this.name = 'AuthError'
	}
}
export default AuthError
